import { USACurrency } from '@loc/helpers/src/currency/data'
import NP from 'number-precision'

import { getCurrentPrice } from './getCurrentPrice'

import type { $Enums } from '@prisma/client'
import type { TProduct } from '../type'
import type { getProductItems } from './getProductItems'

export function getEcommerce({
  userId,
  productPriceList,
  items,
  appName,
  paymentPlatform,
}: {
  userId: string
  productPriceList: TProduct[]
  items: ReturnType<typeof getProductItems>
  appName: $Enums.SubLogAppName
  paymentPlatform?: string
}) {
  const currencyInfo = USACurrency
  const ecommerce = {
    currency: currencyInfo.iso,
    transaction_id: `${userId}_${Date.now()}`,
    payment_platform: paymentPlatform || '',
    appName,
    value: productPriceList.reduce((acc, cur) => {
      const { currencyPrice } = getCurrentPrice({
        productPrice: cur,
      })
      return NP.plus(acc, currencyPrice)
    }, 0),
    renewal: 1,
    items,
    origin_url: window.location.href,
    num_items: items.length,
    content_ids: productPriceList.map((p) => p.priceId),
  }
  return { ecommerce }
}
